export const CheckMarkIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.2845 6.12766L9.07659 15.0809L5.71554 11.7787C5.54048 11.6426 5.26039 11.6426 5.12035 11.7787L4.10503 12.766C3.96499 12.9021 3.96499 13.1745 4.10503 13.3447L8.7965 17.8723C8.97155 18.0426 9.21663 18.0426 9.39169 17.8723L19.895 7.65957C20.035 7.5234 20.035 7.25106 19.895 7.08085L18.8797 6.12766C18.7396 5.95745 18.4595 5.95745 18.2845 6.12766Z"
      fill="#292B29"
    />
  </svg>
);
